import { RemoveButton } from "@/Common/Components/Buttons/RemoveButton";

import styles from "./RemoveContainer.module.scss";

interface IRemoveContainerProps {
    className?: string;
    onRemove?: () => void;
    children: JSX.Element;
}

export function RemoveContainer(props: IRemoveContainerProps): JSX.Element {
    return props.onRemove
        ? (
            <div className={`${props.className} ${styles.container}`}>
                <div className={styles.field}>
                    {props.children}
                </div>
                <div className={styles.removeContainer}>
                    {props.onRemove && <RemoveButton onRemove={() => props.onRemove?.()} />}
                </div>
            </div>
        )
        : props.children;
}
